import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgClass } from '@angular/common';

import { NoopValueAccessorDirective } from '@rp/shared/directives';
import { injectNgControl } from '@rp/utils';
import { TranslateModule } from '@ngx-translate/core';

type Appearance = 'default' | 'success';
type Size = 'm' | 'l';
type LabelPosition = 'before' | 'after';

@Component({
  selector: 'rp-toggle',
  standalone: true,
  templateUrl: './toggle.component.html',
  hostDirectives: [NoopValueAccessorDirective],
  host: {
    '[class]': '"rp-toggle__" + appearance()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSlideToggleModule, ReactiveFormsModule, NgClass, TranslateModule],
})
export class ToggleComponent {
  label = input<string>('');
  appearance = input<Appearance>('default');
  size = input<Size>('m');
  labelPosition = input<LabelPosition>('after');

  ngControl = injectNgControl();
}
